import { Constant, Headers } from "../apiConstants";

const InsertReviewsAPI = async (
  outletID,
  reviewType,
  rating,
  reviewComments,
  tranId
) => {
  const endpoint = Constant.CREATE_REVIEWS;
  const BaseUrl = Constant.BASE_URL;
  try {
    const response = await fetch(BaseUrl + "/" + endpoint, {
      method: "post",
      headers: Headers,
      body: JSON.stringify({
        outletId: outletID,
        reviewType: reviewType,
        ratingValue: rating,
        comments: reviewComments,
        transactionId: tranId
      }),
    });
    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default InsertReviewsAPI;
